<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import MediaLibraryAPI from 'dashboard/api/mediaLibrary';

const props = defineProps({
  item: { type: Object, required: true },
  publishedOnly: { type: Boolean, default: false },
});
const container = ref(null);
const source = ref('');
let observer;
let disposed = false;
async function load() {
  try {
    const { data } = await (props.publishedOnly
      ? MediaLibraryAPI.downloadPublished(props.item.id)
      : MediaLibraryAPI.download(props.item.id));
    if (disposed) return;
    source.value = URL.createObjectURL(
      new Blob([data], { type: props.item.content_type })
    );
  } catch {
    // The file title remains available when its preview cannot be loaded.
  }
}
onMounted(() => {
  if (!props.item.content_type?.startsWith('image/')) return;
  observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) {
      observer.disconnect();
      load();
    }
  });
  observer.observe(container.value);
});
onBeforeUnmount(() => {
  disposed = true;
  observer?.disconnect();
  if (source.value) URL.revokeObjectURL(source.value);
});
</script>

<template>
  <div
    ref="container"
    class="flex items-center justify-center overflow-hidden rounded-lg bg-n-alpha-2"
  >
    <img
      v-if="source"
      :src="source"
      :alt="item.title"
      class="h-full w-full object-contain"
    />
    <span
      v-else
      :class="
        item.content_type?.startsWith('image/')
          ? 'i-lucide-image'
          : 'i-lucide-file-text'
      "
      class="size-6 text-n-slate-11"
      aria-hidden="true"
    />
  </div>
</template>
